import { updateKeyInStore } from 'App';
import {
  HomeSaleStateValues,
  TFixingUpExpensesDoneWithin90DaysOfDateOfSaleItem,
  TImprovementsToPropoertyItem,
  TSaleExpensesItem,
  TStHomeSale,
  updateKey,
} from '../slice';

export const uploadFields: IBaseField<
  | keyof HomeSaleStateValues
  | keyof TStHomeSale
  | keyof TFixingUpExpensesDoneWithin90DaysOfDateOfSaleItem
  | keyof TSaleExpensesItem
  | keyof TImprovementsToPropoertyItem
>[] = [
  {
    name: 'pleaseUploadForm1099S',
    label: 'Please upload form 1099-S',
    type: 'upload',
    tooltip: '',
    comment: true,
    effect: updateKeyInStore(updateKey),
    predicate: (value) => value === 'yes',
    dependentOn: 'taxQuestionnaire.income.homeSale.values.isThePropertyInTheUs',
  },
];
